import { Course, CourseDeep } from '@mc/api'
import { paths } from '@mc/paths'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'

import { formatSubtitle, formatTitle } from 'libs/utils'

export const CONTINUOUS_TRAILERS_EXP_FLAG = 'pen-4573_v1'

export const getTrailerFromCourse = (course: Course | CourseDeep) => {
  const mediaId = course.mediaUuid || course.sampleVideoId

  return {
    id: course.id,
    instructorAvatarUrl: course.primary1x1,
    instructorName: course.instructorName,
    headline:
      formatSubtitle(
        course.title,
        course.instructorName,
        course.isMultiInstructor,
        course.multiInstructorName,
      ) || '',
    slug: course.slug,
    shortDescription: course.marketingCmColumn,
    title:
      formatTitle(
        course.isMultiInstructor,
        course.skill,
        course.instructorName,
      ) || '',
    contentType: TRACK_CONTENT_TYPES.COURSE_TRAILER,
    mediaId,
    courseUrl: paths.courseTypePage(course.type, course.slug),
    contentId: `${course.id}_${mediaId}`,
    primary16x9: course.primary16x9 || '',
  }
}
